import React, { useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Play } from "lucide-react";
import { mediaUrl } from "@/lib/api";

// Vertical Crafts trust/proof player. When finaleAt + finaleCaption are set,
// a gold caption fires only during the finale window for extra impact.
export const CraftVideo = ({ src, poster, eyebrow, heading, finaleAt, finaleCaption, finaleSub }) => {
  const ref = useRef(null);
  const [t, setT] = useState(0);
  const showFinale = finaleAt != null && finaleCaption && t >= Number(finaleAt);

  return (
    <div data-testid="craft-video" id="watch" className="mt-6">
      <div className="relative w-full max-w-[300px] aspect-[9/16] bg-espresso/40 overflow-hidden border border-gold/20">
        <video
          ref={ref}
          src={mediaUrl(src)}
          poster={poster ? mediaUrl(poster) : undefined}
          controls
          playsInline
          preload="metadata"
          onTimeUpdate={(e) => setT(e.currentTarget.currentTime)}
          data-testid="craft-video-player"
          className="w-full h-full object-cover"
        />
        <AnimatePresence>
          {showFinale && (
            <motion.div
              key="finale"
              data-testid="craft-video-finale"
              initial={{ opacity: 0, y: 24, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 12 }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
              className="pointer-events-none absolute inset-x-0 bottom-[16%] flex justify-center px-4"
            >
              <motion.div
                animate={{ scale: [1, 1.035, 1] }}
                transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
                className="craft-finale-flash bg-cocoa/85 backdrop-blur-sm border border-gold/60 rounded-full px-5 py-2.5 text-center"
              >
                <p className="font-serif text-gold text-lg leading-none">{finaleCaption}</p>
                {finaleSub && (
                  <p className="mt-1 text-[0.56rem] tracking-[0.22em] uppercase text-cream/80">{finaleSub}</p>
                )}
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <p className="mt-2.5 text-[0.64rem] tracking-[0.18em] uppercase text-gold flex items-center gap-1.5">
        <Play size={12} className="fill-current" /> {eyebrow || "Watch"}{heading ? ` — ${heading}` : ""}
      </p>
    </div>
  );
};

export default CraftVideo;
